import { Wording } from '@/types';

export const FITNESS_WORDING_NO: Wording = {
  components_header_media_content: 'Treningsøkter',
  components_header_media_1: 'For menn',
  components_header_media_2: 'For kvinner',
  components_header_text1: 'Oppskrifter',
  components_header_text2: 'Blogg',
  components_header_members: 'Medlemmer',
  hero_text: 'Hold kroppen din i form og sterk',
  hero_button_text: 'Start treningsreisen din',
  components_ressources_section_title: 'RESSURSER',
  components_ressources_subheader_text: 'Alle ressursene du trenger for en sunn livsstil',
  components_ressources_span_text: 'Gi næring til ditt velvære: Slipp løs en mengde ressurser for helhetlig helse og et sunt liv, inkludert ekspertveiledning om trening, ernæring og bærekraftig livsstil.',
  components_ressources_card_1_title: 'Motivasjon',
  components_ressources_card_1_text: 'Korte utbrudd av motivasjon for varige treningsvaner.',
  components_ressources_card_2_title: 'Kosthold',
  components_ressources_card_2_text: 'Smarte kostholdstips for et sunnere og sterkere deg.',
  components_ressources_link: 'Se videoer',
  components_notes_and_google_title_1: 'Trening',
  components_notes_and_google_title_2: 'Vanlig rutine',
  components_notes_and_google_title_3: 'Kostholdsvedlikehold',
  components_review_google_text: 'Anmeldelse på Google',
  media_content_section_title: 'TRENING',
  media_content_section_subheader_text: 'Våre videoer',
  text_media_1: 'Menn',
  text_media_2: 'Kvinner',
  media_content_section_button_more: 'Flere videoer',
  text2_section_title: 'BLOGG',
  text2_section_subheader_text: 'Artikler og nyheter',
  text2_section_button_more: 'Flere artikler',
  components_text1_section_title: 'OPPSKRIFTER',
  components_text1_subheader_text: 'Sunt kosthold for ditt aktive liv',
  components_text1_span_text: 'Matlaging med vitalitet: Utforsk en verden av smakfull trening med våre raske og næringsrike oppskrifter.',
  components_text1_card_1_title: 'Kickstart dagen din',
  components_text1_card_1_text: 'Start morgenen riktig med næringsrike og proteinrike frokostalternativer.',
  components_text1_card_3_title: 'Matpakker med kraft',
  components_text1_card_3_text: 'Oppdag deilige og praktiske lunsjoppskrifter designet for din aktive livsstil. Fra fargerike salater til proteinrike wraps, holder disse oppskriftene deg mett og fokusert.',
  components_text1_card_2_title: 'Middager for restitusjon',
  components_text1_card_2_text: 'Utforsk et utvalg av magert protein, fullkorn og livlige grønnsaker for en tilfredsstillende avslutning på dagen.',
  components_text1_link: 'Se alle oppskrifter',
  components_footer_text: 'Øk styrken din, tenn lidenskapen din: Treningssenteret ditt, forvandlingen din.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registreringsnummer',
  components_footer_legal: 'Juridisk',
  components_footer_terms: 'Vilkår og betingelser',
  components_footer_privacy: 'Personvernerklæring',
  button_load_more: 'Last inn mer',
  page_media_1_content_hero_text: 'Treningsøkter for menn',
  page_media_content_menu_biceps: 'Biceps',
  page_media_content_menu_triceps: 'Triceps',
  page_media_content_menu_back: 'Tilbake',
  page_media_content_menu_chest: 'Kiste',
  page_media_content_menu_legs: 'Bein',
  page_media_content_menu_shoulders: 'Skuldre',
  page_media_content_menu_abdominals: 'Magemuskler',
  page_media_2_content_hero_text: 'Treningsøkter for kvinner',
  page_text1_hero_text: 'Oppskrifter',
  page_text1_section_title: 'Ernæring',
  page_text1_subheader_text: 'Oppskrifter',
  page_text2_hero_text: 'Bloggen vår',
  page_text2_section_title: 'Blogg',
  page_text2_subheader_text: 'Artikler og nyheter',
  enter_email_title: 'Vennligst skriv inn e-postadressen din for å fortsette',
  enter_email_placeholder_email: 'E-post',
  enter_email_button_enter: 'Gå',
  components_login_success_text: 'Innlogging vellykket!',
  components_card_link_media_content: 'Se nå',
  components_card_link_text1_content: 'Se oppskrift',
  components_card_link_text2_content: 'Vis artikkel',
  france: 'Frankrike',
  cyprus: 'Kypros',
  page_media_content_menu_all: 'ALLE',
};